const Section = ({ title, subtitle, icon, children }) => (
  <div className="bg-gradient-to-br from-white to-gray-50 border border-gray-200 p-6 mb-8 shadow-sm hover:shadow-md transition-shadow">
    <div className="flex items-start gap-3 mb-6">
      {icon && (
        <div className="p-2 bg-primary-100 text-primary-600 rounded-lg">
          {icon}
        </div>
      )}
      <div className="flex-1">
        <h2 className="text-xl font-semibold text-gray-900 mb-1">{title}</h2>
        {subtitle && (
          <p className="text-sm text-gray-600">{subtitle}</p>
        )}
      </div>
    </div>
    {children}
  </div>
);

export default Section;